import * as React from "react";
import Modal from "../Modal";
import DatePickerInput from "../Datepicker";
import Selectfield from "../Merchant/Selectfield";
import Textarea from "../Textarea";
import DropdownCheckbox from "./DropdownCheckbox";
import Button from "../Button";
import { Colors } from "../../config/Constants";

interface Props {
  data: any;
  onToggleModalState: (event: boolean) => void;
  onSoldoutChange: (event: any) => void;
  onProductSelect: (event: any) => void;
  onSoldoutSubmit: () => void;
  errors: any;
}

const SoldOutModal = ({
  onToggleModalState,
  data,
  onSoldoutChange,
  onProductSelect,
  onSoldoutSubmit,
  errors,
}: Props) => {
  return (
    <Modal
      variant={"none"}
      setOpenOrClose={(status) => onToggleModalState(status)}
      width={"300px"}
    >
      <div
        style={{
          padding: "1.5rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div />
          <div>Sold Out</div>
          <img
            onClick={() => onToggleModalState(false)}
            style={{ width: "1rem", height: "1rem" }}
            src={require("../../assets/images/close.png")}
          />
        </div>

        <div style={{ flex: 1 }}>
          <DatePickerInput
            required={true}
            minDate={new Date()}
            label="Date"
            width="236px"
            value={data?.date}
            onChange={(e) =>
              onSoldoutChange({ target: { value: e, name: "date" } })
            }
            error={errors["date"]}
          />
        </div>

        <DropdownCheckbox
          name="product"
          label="Product"
          data={data.products}
          required
          helperText={errors["product"]}
          disabled={false}
          placeholder="Select product"
          onProductSelect={onProductSelect}
        />
        <Textarea
          name="comment"
          placeholder={""}
          onChange={onSoldoutChange}
          value={data?.comment}
          label="Comments"
          error={errors["comment"]}
          required
        />
        <Button
          color={Colors.red}
          label="Submit"
          variant="filled"
          onClick={onSoldoutSubmit}
        />
      </div>
    </Modal>
  );
};

export default SoldOutModal;
